import { entityViewInset } from '@/components/common/EntityView';
import FadeInBox from '@/components/common/FadeInBox';
import { FlexCol } from '@/components/common/Flex';
import { scrollShadowStyle } from '@/components/common/styleHelpers';
import { Header } from '@/components/common/Typography';
import { Box, BoxProps, Spacer } from '@chakra-ui/react';
import OpenIraFlowFooter from './OpenIraFlowFooter';

interface OpenIraFlowStepProps extends BoxProps {
    headerTitle?: string;
    onBack: VoidFunction;
    onNext: VoidFunction;
    nextButtonText?: string;
    isNextDisabled?: boolean;
    isSubmitting?: boolean;
    footerMiddleContent?: JSX.Element;
}

const OpenIraFlowStep = ({
    headerTitle,
    onBack,
    onNext,
    nextButtonText,
    isNextDisabled,
    isSubmitting,
    footerMiddleContent,
    children,
    ...props
}: OpenIraFlowStepProps) => {
    return (
        <FadeInBox h="full" w="full">
            <Box
                position="relative"
                overflow="auto"
                {...scrollShadowStyle()}
                px={entityViewInset}
                pb={8}
                {...props}
            >
                {headerTitle && <Header mb={6}>{headerTitle}</Header>}
                <FlexCol grow={1}>{children}</FlexCol>
            </Box>
            <Spacer />
            <OpenIraFlowFooter
                onBack={onBack}
                onNext={onNext}
                nextButtonText={nextButtonText}
                isNextDisabled={isNextDisabled}
                isSubmitting={isSubmitting}
                footerMiddleContent={footerMiddleContent}
            />
        </FadeInBox>
    );
};

export default OpenIraFlowStep;
